<template>
  <div class="pic-img">
    <swiper :options="swiperOption"  ref="mySwiper">
      <!-- 渲染内容 -->
      <swiper-slide v-for="(item,index) in items" :key="index">
      	<a :href="item.url" target="_blank" style="display:block;width:100%;height:100%">
          <img :src="isMobile?item.m_img:item.pc_img" alt="" style="vertical-align:middle">
        </a>
      </swiper-slide>
      <!-- 轮播小圆点 -->
      <div class="swiper-pagination" slot="pagination" v-if="items.length!==1"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'
import myBus from './vueBus.js'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: ['items'],
  data () {
    return {
      swiperOption: {
        effect: 'fade',
        loop: true,
        autoplay: 3000,
        speed: 1000,
        fade: {
          crossFade: false
        },
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false
      }
    }
  },
  created () {},
  // 定义这个swiper对象
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  mounted () {
  },
  beforeDestroy () {
    myBus.$off('changeDevice')
  }
}
</script>
<style scoped>
@import '~swiper/dist/css/swiper.css';
</style>



// WEBPACK FOOTER //
// picSwipe.vue?17ca1435